import { LightAction } from "components/ui/LightAction";
import { CommercialIcon } from "components/icons/customIcons";
import { AddIcon } from "components/icons/Icons";
import { FC } from "react";

interface RealEstateEmptyStateProps {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
}

export const RealEstateEmptyState: FC<RealEstateEmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction
}) => (
  <div className="flex flex-col items-center justify-center py-12 text-center rounded-xl border bg-white">
    <CommercialIcon className="h-16 w-16 text-gray-300 mb-4" />
    <h3 className="text-lg font-medium text-gray-900 mb-2">
      {title}
    </h3>
    <p className="text-gray-500 mb-6 max-w-md">
      {description}
    </p>
    <LightAction
      icon={AddIcon}
      label={actionLabel}
      onClick={onAction}
    />
  </div>
);
